import React from 'react';

const LABEL_STYLE = {
  display: 'block',
  fontSize: 10,
  fontFamily: "'Space Grotesk', sans-serif",
  fontWeight: 600,
  letterSpacing: '0.5px',
  textTransform: 'uppercase',
  color: '#717782',
  marginBottom: 4,
};

export default function Select({
  label,
  error,
  required,
  options = [],
  placeholder,
  className = '',
  wrapperClassName = '',
  ...props
}) {
  const selectId = props.id || props.name || `select-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className={`leading-normal ${wrapperClassName}`}>
      {label && (
        <label htmlFor={selectId} style={LABEL_STYLE}>
          {label}
          {required && <span style={{ color: '#ba1a1a', marginLeft: 2 }}>*</span>}
        </label>
      )}
      <div className="hud-scanline relative">
        <select
          id={selectId}
          style={{
            appearance: 'none',
            WebkitAppearance: 'none',
            width: '100%',
            padding: '8px 24px 8px 0',
            background: 'transparent',
            border: 'none',
            borderBottom: `1px solid ${error ? '#ba1a1a' : '#c1c7d3'}`,
            borderRadius: 0,
            fontSize: 14,
            color: '#191c21',
            fontFamily: "'Noto Sans JP', sans-serif",
            outline: 'none',
            cursor: 'pointer',
            boxSizing: 'border-box',
          }}
          className={className}
          {...props}
        >
          {placeholder && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {options.map((option) => (
            <option
              key={option.value}
              value={option.value}
              disabled={option.disabled}
            >
              {option.label}
            </option>
          ))}
        </select>
        {/* カスタム矢印アイコン */}
        <div
          className="absolute right-0 top-1/2 -translate-y-1/2 pointer-events-none"
          style={{ color: '#717782' }}
        >
          <span className="material-symbols-outlined" style={{ fontSize: 16 }}>expand_more</span>
        </div>
      </div>
      {error && (
        <p style={{ marginTop: 4, fontSize: 12, color: '#ba1a1a', fontFamily: "'Noto Sans JP', sans-serif" }}>
          {error}
        </p>
      )}
    </div>
  );
}
